"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Actions = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _Scrim = _interopRequireDefault(require("../Scrim"));

var _ariaIsolate = _interopRequireDefault(require("../../utils/aria-isolate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var noop = function noop() {};

var Actions = function Actions(_ref) {
  var children = _ref.children;
  return _react["default"].createElement("div", {
    className: "dqpl-buttons"
  }, children);
};

exports.Actions = Actions;
Actions.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]).isRequired
};
/**
 * Cauldron <Alert /> component
 */

var Alert =
/*#__PURE__*/
function (_Component) {
  _inherits(Alert, _Component);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Alert).call(this, props));
    _this.state = {
      show: props.show
    };
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    _this.focusContent = _this.focusContent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Alert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.show) {
        this.attachIsolator(function () {
          return setTimeout(_this2.focusContent);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var showChange = prevProps.show !== this.props.show;

      if (!showChange) {
        return;
      }

      this.setState({
        show: this.props.show
      }, function () {
        if (_this3.props.show) {
          _this3.attachIsolator(_this3.focusContent);
        } else {
          _this3.close();
        }
      });
    }
  }, {
    key: "attachIsolator",
    value: function attachIsolator(done) {
      this.setState({
        isolator: new _ariaIsolate["default"](this.element)
      }, done);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var show = this.state.show;
      var _this$props = this.props,
          alertRef = _this$props.alertRef,
          contentRef = _this$props.contentRef,
          forceAction = _this$props.forceAction,
          className = _this$props.className;
      var cl = className || '';
      var alertClass = show ? 'dqpl-dialog-show' : '';

      if (!show) {
        return null;
      }

      return _react["default"].createElement(_focusTrapReact["default"], {
        focusTrapOptions: {
          onDeactivate: this.close,
          escapeDeactivates: !forceAction,
          fallbackFocus: '.dqpl-dialog-inner'
        }
      }, _react["default"].createElement("div", {
        className: ['dqpl-alert', alertClass, cl].join(' '),
        role: "alertdialog",
        ref: function ref(el) {
          _this4.element = el;
          alertRef(el);
        }
      }, _react["default"].createElement("div", {
        className: "dqpl-dialog-inner",
        ref: function ref(el) {
          _this4.content = el;
          contentRef(el);
        },
        tabIndex: -1
      }, _react["default"].createElement("div", {
        className: "dqpl-content"
      }, this.props.children)), _react["default"].createElement(_Scrim["default"], {
        show: show
      })));
    }
  }, {
    key: "close",
    value: function close() {
      this.state.isolator.deactivate();
      this.setState({
        show: false
      });
      this.props.onClose();
    }
  }, {
    key: "focusContent",
    value: function focusContent() {
      if (this.content) {
        this.content.focus();
      }

      this.state.isolator.activate();
    }
  }]);

  return Alert;
}(_react.Component);

exports["default"] = Alert;
Alert.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]).isRequired,
  show: _propTypes["default"].bool,
  contentRef: _propTypes["default"].func,
  alertRef: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  forceAction: _propTypes["default"].bool
};
Alert.defaultProps = {
  onClose: noop,
  forceAction: false,
  alertRef: noop,
  contentRef: noop
};